import aboutImg from "../../assets/images/about1.jpg";

import carEco from "../../assets/images/PNG/car_eco.png";
import carFlash from "../../assets/images/PNG/car_with_flash.png";
import ecology from "../../assets/images/PNG/ecology.png";
import batteryPlug from "../../assets/images/PNG/battery_plug.png";
import { Link } from "react-router-dom";

function About() {
    return (
        <section className="about pb-10 pt-11">
            <div className="container">
                <div className="about-inner pt-11">
                    <div className="row align-items-center gy-5 gx-xl-5">

                        {/* COUNTERS */}
                        <div className="col-xl-2 col-md-6 order-3 order-xl-1">
                            <div className="about-counter text-center">

                                <div className="counter-box mb-6 pb-6 border-bottom border-1 border-grey1">
                                    <h2 className="green">
                                        <span className="num">5</span>+
                                    </h2>
                                    <span className="text-uppercase black fw-medium">
                                        Years Experience
                                    </span>
                                </div>

                                <div className="counter-box mb-6 pb-6 border-bottom border-1 border-grey1">
                                    <h2 className="green">
                                        <span className="num">40</span>+
                                    </h2>
                                    <span className="text-uppercase black fw-medium">
                                        Charging Stations
                                    </span>
                                </div>

                                <div className="counter-box mb-6 pb-6 border-bottom border-1 border-grey1">
                                    <h2 className="green">
                                        <span className="num">5</span>K+
                                    </h2>
                                    <span className="text-uppercase black fw-medium">
                                        Positive Reviews
                                    </span>
                                </div>

                                <div className="counter-box">
                                    <h2 className="green">
                                        <span className="num">20</span>+
                                    </h2>
                                    <span className="text-uppercase black fw-medium">
                                        Happy Customers
                                    </span>
                                </div>

                            </div>
                        </div>

                        {/* IMAGE */}
                        <div className="col-xl-4 col-md-6 order-2">
                            <div className="about-image">
                                <img
                                    src={aboutImg}
                                    alt="about"
                                    className="w-100 rounded2"
                                />
                            </div>
                        </div>

                        {/* CONTENT */}
                        <div className="col-xl-6 order-1 order-xl-3">
                            <div className="about-info text-center text-xl-start">

                                <div className="section-title mb-6">
                                    <h6 className="text-uppercase fw-medium green1 mb-1">
                                        About Denial Enterprise
                                    </h6>

                                    <h2 className="ps-4 border-start border-3 border-green">
                                        Reliable solutions for all{" "}
                                        <span className="green">ev charging</span> programs!
                                    </h2>
                                </div>

                                <div className="section-body">
                                    <p className="mb-4 pb-4 border-dashed border-top-0 border-2 border-start-0 border-end-0">
                                        Denial Enterprise is committed to powering the future of transportation. We provide seamless, high-performance charging infrastructure designed to bridge the gap between innovation and everyday reliability.
                                    </p>

                                    {/* SERVICES */}
                                    <div className="about-services  mb-6">
                                        <div className="row g-0">

                                            <div className="col-md-6">
                                                <div className="about-service-box p-4 d-flex align-items-center bg-grey rounded2 rounded-bottom-0">
                                                    <img src={carEco} alt="service" className="icon-filter me-3" />
                                                    <a href="/" className="black text-decoration-none text-capitalize  fw-bold">
                                                        Turnkey EVCS Infrastructure
                                                    </a>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="about-service-box p-4 d-flex align-items-center bg-white">
                                                    <img src={carFlash} alt="service" className="icon-filter me-3" />
                                                    <a href="/" className="black text-decoration-none text-capitalize fw-bold">
                                                        Precision Metering Services
                                                    </a>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="about-service-box p-4 d-flex align-items-center bg-white">
                                                    <img src={ecology} alt="service" className="icon-filter me-3" />
                                                    <a href="/" className="black text-decoration-none text-capitalize fw-bold">
                                                        Proactive Maintenance & Reliability
                                                    </a>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="about-service-box p-4 d-flex align-items-center bg-grey rounded2 rounded-top-0">
                                                    <img src={batteryPlug} alt="service" className="icon-filter me-3" />
                                                    <a href="/" className="black text-decoration-none text-capitalize fw-bold">
                                                        Comprehensive Grid Connectivity
                                                    </a>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <li className="list-unstyled">
                                        <Link to="/about" className="btn btn1 bg-darkgreen text-white">
                                            More About
                                        </Link>
                                    </li>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;
